<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YkptlR/tc-custom/9781612434216.jpg?1728851632177" alt="This image is the cover for the book Ketogenic Diet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ketogenic Diet
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Get started on the keto diet with the original guide to triggering ketosis with a low carb, high fat, healthy eating plan—including recipes!</b><br/><br/> Not all low-carb diets are created equal. Unlike many of the fad diets out there, the ketogenic diet is scientifically proven to change how the brain gets energy and the body dissolves fat. Studies have shown that the ketogenic diet’s program—a high in fat, moderate in protein and very low in carbs approach—guarantees you’ll lose weight by: </p><p> ·      Powerfully suppressing appetite </p><p> ·      Effectively stabilizing blood sugar </p><p> ·      Naturally enhancing mood </p><p> ·      And dramatically reducing fat storage </p><p><i>The Ketogenic Diet</i> includes a quick-start guide to rapid weight loss, a surefire plan to eliminate carbs and fat-burning advice that works. Using the recipes and tips in this book, you will learn to avoid trigger foods, gauge the difference between good and bad fats, and steer clear of nutrient-poor carbs. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kristen Mancinelli
      </h2>
      
      <p class="authorDescription body article">Kristen Mancinelli, MS, RDN, is a nutrition scientist and educator based in Los Angeles. She counsels individuals in weight loss and prevention of chronic disease, and writes for popular media on the subject of nutrition and health. Learn more about Ms. Mancinelli at kristenmancinelli.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2115f554